import { EventEntity } from "../domain/event.entity";
import { dtoToEntity, EventDTO } from "./event.dto";
import { HttpClient } from "../../../lib/http";

export interface EventFiltersRequest {
  startDate: string;
  endDate: string;
}

export interface GetFiltersRequestProps {
  filters?: EventFiltersRequest;
  size: number;
  page: number;
}

export interface PaginatedResult<T> {
  data: T[];
  total: number;
  page: number;
  size: number;
}

export async function findEvents(
  baseUrl: string,
  filters: GetFiltersRequestProps
): Promise<PaginatedResult<EventEntity>> {
  const apiClient = new HttpClient(baseUrl);
  const response = await apiClient.get<PaginatedResult<EventDTO>>("/api/v1/events", {
    params: {
      startDate: filters.filters?.startDate,
      endDate: filters.filters?.endDate,
      page: filters.page + 1,
      size: filters.size,
    },
  });
  const events = dtoToEntity(response.data);
  return {
    data: events,
    total: response.total,
    page: response.page,
    size: response.size,
  };
}
